import { StopNew } from "../../../ducks/data/route-with-stops/types";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import { AppLauncher } from "@capacitor/app-launcher";
import { isMobile } from "../../../helpers/mobile";
import "./stop-component.scss";

const StopPhone = ({ stop }: { stop: StopNew }) => {
  if (!stop.phone) {
    return null;
  }

  const handlePhoneClick = async (e: React.MouseEvent) => {
    if (isMobile) {
      e.preventDefault();
      await AppLauncher.openUrl({ url: `tel:${stop.phone}` });
    }
  };

  return (
    <div>
      <a
        href={`tel:${stop.phone}`}
        rel="noreferrer"
        className="stop-component"
        onClick={handlePhoneClick}
      >
        <PhoneInTalkOutlinedIcon className="stop-component-icon" />
        <div className="flex-grow">{stop.phone}</div>
      </a>
    </div>
  );
};

export default StopPhone;
